import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import { EffectCoverflow, Navigation } from 'swiper/modules';
import './carousel1.scss'
// Importer des images pour les slides
import img1 from '../../images/dipavali-974.png';
import img2 from '../../images/13juillet-saintpierre.jpg';
import img3 from '../../images/cilaos.jpg';
import img4 from '../../images/concours-leclerc.jpg';
import img5 from '../../images/dipavali2024.jpg';
import img6 from '../../images/flamme-olympique.jpeg';
import img7 from '../../images/geekali.jpg';
import img8 from '../../images/geekali1.jpg';
import img9 from '../../images/Matarom-mangAli.jpg';
import img10 from '../../images/prestation.jpg';
import img11 from '../../images/prestation-creche-974.jpg';

const Carousel = () => {
  return (
    <div className="swiper-container">

<h1 className='slide-title'>Flowers galerie</h1>
      <Swiper


        modules={[EffectCoverflow, Navigation]} // Utilisation du module EffectCoverflow
        spaceBetween={10} // Espacement entre les slides
        slidesPerView={3} // Nombre de slides visibles
        
        navigation // Navigation (prev/next buttons)
        effect="coverflow" // Application de l'effet coverflow
        
  
      
        coverflowEffect={{
          rotate: 50, // Rotation des slides
          stretch: 0, // Déformation des slides
          depth: 100, // Profondeur de l'effet
          modifier: 0.8, // Modificateur pour ajuster l'effet global
          slideShadows: true, // Ombres pour les slides

        
          
        }}
        loop={true} // Activation du loop
        
        //Afficher une seule image en version mobile
        breakpoints={{
          0: {
            slidesPerView: 1, // Affiche 1 slide sur mobile
          },
          758: {
            slidesPerView: 3, // Affiche 3 slides à partir de 768px
          }
        }}
      >
       
        <SwiperSlide>
          
          <img src={img1} alt="" className="gallery-item" />
        </SwiperSlide>
        
        <SwiperSlide>
          <img src={img2} alt="" className="gallery-item" />
        </SwiperSlide>
        
        <SwiperSlide>
          <img src={img3} alt="" className="gallery-item" />
        </SwiperSlide>
        
        <SwiperSlide>
          <img src={img4} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img5} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img6} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img7} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img8} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img9} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img10} alt="" className="gallery-item" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img11} alt="" className="gallery-item" />
        </SwiperSlide>
        {/* Vous pouvez ajouter d'autres slides */}
      </Swiper>
    </div>
  );
};

export default Carousel;
